"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setElementkitConfig = void 0;
const ElementBaseConfig_1 = require("./ElementBaseConfig");
Object.defineProperty(exports, "setElementkitConfig", { enumerable: true, get: function () { return ElementBaseConfig_1.setElementkitConfig; } });
